import {
  action,
  makeObservable,
  observable,
} from 'mobx';

import moment from 'moment';

class UIStore {
  loading = false;

  showError = false;

  errorMessage = null;

  highlightedUnit = null;

  vin = null;

  year = null;

  make = null;

  makeName = null;

  model = null;

  modelName = null;

  yearList = null;

  makesList = null;

  modelsList = null;

  multiVehicles = null

  externalReferrer = false;

  predictionMonthsOut = null;

  startDate = moment().subtract(60, 'days').toDate();

  endDate = moment().toDate();

  dateRange = [];

  // Date slider

  selectedStartDate = null;

  selectedEndDate = null;

  updatedStartDate = null;

  updatedEndDate = null;

  selectedInspectionOptions = [];

  vehicleComparables = [];

  inspectionOptions = [];

  conditionScore= null;

  condition = [];

  conditionOptions = [];

  chartData = null;

  mileage = '';

    updated = null;

    min = null;

    max = null;

    activeTab = 0;

    // Location slider

    valueLocation = null;

    constructor() {
      makeObservable(this, {
        loading: observable,
        showError: observable,
        errorMessage: observable,
        highlightedUnit: observable,
        activeTab: observable,
        inspectionOptions: observable,
        modelName: observable,
        makeName: observable,
        conditionScore: observable,
        condition: observable,
        conditionOptions: observable,
        chartData: observable,
        setActiveTab: action,
        setLoading: action,
        setShowError: action,
        setHighlightedUnit: action,
        setProperty: action,
        reset: action,
        setStartDate: action,
        setEndDate: action,
        setRange: action,
        onChange: action,
        onUpdate: action,
        setSelectedInspectionOptions: action,
        setInspectionOptions: action,
        vin: observable,
        year: observable,
        make: observable,
        model: observable,
        yearList: observable,
        makesList: observable,
        modelsList: observable,
        startDate: observable,
        endDate: observable,
        dateRange: observable,
        min: observable,
        max: observable,
        mileage: observable,
        selectedStartDate: observable,
        selectedEndDate: observable,
        updatedStartDate: observable,
        updatedEndDate: observable,
        externalReferrer: observable,
        selectedInspectionOptions: observable,
        predictionMonthsOut: observable,
        vehicleComparables: observable,
        multiVehicles: observable,
        valueLocation: observable,
      });
    }

  setLoading = (value) => {
    this.loading = value;
  };

  setShowError = (value, message = null) => {
    this.showError = value;
    this.errorMessage = message;
  };

  setHighlightedUnit = (value) => {
    this.highlightedUnit = value;
  };

  setProperty = (key, value) => {
    this[key] = value;
  };

  reset = () => {
    this.year = null;
    this.vin = null;
    this.make = null;
    this.model = null;
    this.makesList = null;
    this.modelsList = null;
    this.mileage = null;
    this.makeName = null;
    this.modelName = null;
    this.multiVehicles = null;
    this.vehicleCategory = null;
  };

  setStartDate = (value) => {
    this.startDate = value;
  };

  setEndDate = (value) => {
    this.endDate = value;
  };

  setRange = ([start, end]) => {
    this.dateRange = [start, end];

    this.selectedStartDate = this.selectedStartDate === null ? moment(start).add(12, 'M').toDate() : moment(start).toDate();
    this.selectedEndDate = moment(end).toDate();

    this.min = moment(start).toDate();
    this.max = moment(end).toDate();
    this.updatedStartDate = moment(start).toDate();
    this.updatedEndDate = moment(end).toDate();
  };

  onChange = ([start, end]) => {
    this.selectedStartDate = new Date(start);
    this.selectedEndDate = new Date(end);
  };

  onUpdate = ([start, end]) => {
    this.updatedStartDate = new Date(start);
    this.updatedEndDate = new Date(end);
  };

  setActiveTab = (value) => this.activeTab = value;

  setSelectedInspectionOptions = (value) => this.selectedInspectionOptions = value;

  setInspectionOptions = (value) => this.inspectionOptions = value;
}
export default UIStore;
